export default "__VITE_ASSET__DD2$ewOc__"